@if (shouldShowAttentionNeeded()) {
  <span
    class="dot-indicator"
    tabindex="0"
    role="img"
    [style.min-width.px]="size"
    [style.min-height.px]="size"
    [style.max-width.px]="size"
    [style.max-height.px]="size"
    [style.border-radius.px]="size"
    [class.bordered]="hasBorder"
    [ngClass]="[color, getBorderColor(), getAnimation()]"
    [matTooltip]="getTooltip() | translate"
    [attr.aria-label]="getTooltip() | translate">
  </span>
}
